<script lang="ts" setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import HistorialFacturas from './HistorialFacturas.vue'
import RegistroFacturas from './RegistroFacturas.vue'
const store = useStore()
const idInstitution = computed(() => store.getters['global/currentInstitution'])
const tabs = [
	{ icon: 'receipt_long', title: 'Facturas', content: 'Facturas' },
	{ icon: 'receipt_long', title: 'Historial', content: 'Historial' }
]
const value = ref(tabs[0].title)
const currentTab = computed(() => tabs.find(({ title }) => title === value.value))
</script>
<template>
	<va-card class="bitacora-card">
		<va-card-title class="header-gradient">
			<div class="header-content">
				<div class="header-main">
					<div class="header-icon-wrapper">
						<va-icon name="receipt_long" class="header-icon" />
					</div>
					<div class="header-text">
						<h2 class="header-title">Facturación</h2>
					</div>
				</div>
			</div>
		</va-card-title>

		<va-card-content class="card-content">
			<VaTabs v-model="value" grow>
				<template #tabs>
					<VaTab v-for="tab in tabs" :key="tab.title" :name="tab.title">
						<VaIcon :name="tab.icon" size="small" class="mr-2" />
						{{ tab.title }}
					</VaTab>
				</template>
				<VaCard class="full-width-card" style="margin-top: 1rem">
					<VaCardContent v-if="currentTab?.title === 'Facturas'">
						<RegistroFacturas :idInstitution="idInstitution" :institutionName="store.state.global.selectedInstitution.nombreInstitucion" />
					</VaCardContent>
					<VaCardContent v-if="currentTab?.title === 'Historial'">
						<HistorialFacturas :idInstitution="idInstitution" />
					</VaCardContent>
				</VaCard>
			</VaTabs>
		</va-card-content>
	</va-card>
</template>
<style scoped>
:deep(.scrollable-table .va-data-table) {
	width: 100%;
	height: auto;
}

:deep(.scrollable-table .va-data-table__table-wrapper) {
	overflow: visible !important;
	height: auto !important;
}

:deep(.scrollable-table table) {
	width: 100%;
}

:deep(.scrollable-table .va-data-table__table) {
	background: transparent;
	width: 100%;
}

:deep(.scrollable-table .va-data-table__table thead) {
	background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
	position: sticky;
	top: 0;
	z-index: 10;
}

:deep(.scrollable-table .va-data-table__table thead th) {
	padding: 1rem 1.25rem;
	font-weight: 700;
	color: #1a202c;
	font-size: 0.875rem;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	border-bottom: 2px solid #e2e8f0;
}

:deep(.scrollable-table .va-data-table__table tbody tr) {
	transition: all 0.2s ease;
	border-bottom: 1px solid #f1f5f9;
}

:deep(.scrollable-table .va-data-table__table tbody tr:hover) {
	background: linear-gradient(90deg, rgba(37, 99, 235, 0.05) 0%, rgba(37, 99, 235, 0.02) 100%);
	transform: translateX(2px);
	box-shadow: 0 2px 8px rgba(37, 99, 235, 0.1);
}

:deep(.scrollable-table .va-data-table__table tbody td) {
	padding: 1.25rem 1.25rem;
	color: #475569;
	font-size: 0.9375rem;
	vertical-align: middle;
}

/* Animaciones */
@keyframes fadeInUp {
	from {
		opacity: 0;
		transform: translateY(30px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

@keyframes float {
	0%,
	100% {
		transform: translateY(0);
	}
	50% {
		transform: translateY(-10px);
	}
}

@media (max-width: 768px) {
	:deep(.scrollable-table .va-data-table__table thead th),
	:deep(.scrollable-table .va-data-table__table tbody td) {
		padding: 0.75rem 0.5rem;
		font-size: 0.8125rem;
	}
}

/* Animaciones */
@keyframes fadeInUp {
	from {
		opacity: 0;
		transform: translateY(30px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

@keyframes fadeInScale {
	from {
		opacity: 0;
		transform: scale(0.9);
	}
	to {
		opacity: 1;
		transform: scale(1);
	}
}

@keyframes slideInLeft {
	from {
		opacity: 0;
		transform: translateX(-20px);
	}
	to {
		opacity: 1;
		transform: translateX(0);
	}
}

@keyframes pulse {
	0%,
	100% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.1);
	}
}

@keyframes shine {
	0% {
		transform: translateX(-100%) translateY(-100%) rotate(45deg);
	}
	100% {
		transform: translateX(100%) translateY(100%) rotate(45deg);
	}
}

@keyframes float {
	0%,
	100% {
		transform: translateY(0);
	}
	50% {
		transform: translateY(-10px);
	}
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

/* Asegurar que la card dentro de VaTabs ocupe todo el ancho */
:deep(.va-tabs) {
	width: 100%;
}

:deep(.va-tabs__content) {
	width: 100%;
	display: block;
}

:deep(.va-tabs__content > .va-card) {
	width: 100% !important;
	max-width: 100% !important;
	margin-left: 0 !important;
	margin-right: 0 !important;
}

/* Animaciones */
@keyframes fadeInUp {
	from {
		opacity: 0;
		transform: translateY(30px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

@keyframes fadeInScale {
	from {
		opacity: 0;
		transform: scale(0.9);
	}
	to {
		opacity: 1;
		transform: scale(1);
	}
}

@keyframes slideInLeft {
	from {
		opacity: 0;
		transform: translateX(-20px);
	}
	to {
		opacity: 1;
		transform: translateX(0);
	}
}

@keyframes pulse {
	0%,
	100% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.1);
	}
}

@keyframes shine {
	0% {
		transform: translateX(-100%) translateY(-100%) rotate(45deg);
	}
	100% {
		transform: translateX(100%) translateY(100%) rotate(45deg);
	}
}

@keyframes float {
	0%,
	100% {
		transform: translateY(0);
	}
	50% {
		transform: translateY(-10px);
	}
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
.bitacora-card {
	border-radius: 20px;
	padding: 1rem;
	box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
	animation: fadeInUp 0.6s ease-out;
	overflow: hidden;
	background: white;
	border: none;
	width: 100%;
	display: flex;
	flex-direction: column;
}

/* Header mejorado */
.header-gradient {
	background: #062342;
	padding: 0.5rem;
	border-radius: 0;
	position: relative;
	flex-shrink: 0;
}

.header-gradient::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, transparent 100%);
	pointer-events: none;
}

.header-content {
	position: relative;
	z-index: 1;
}

.header-main {
	display: flex;
	align-items: center;
	gap: 1.5rem;
}

.header-icon-wrapper {
	width: 64px;
	height: 64px;
	border-radius: 16px;
	background: rgba(255, 255, 255, 0.2);
	backdrop-filter: blur(10px);
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
	transition: all 0.3s ease;
}

.header-icon-wrapper:hover {
	transform: scale(1.1) rotate(5deg);
	background: rgba(255, 255, 255, 0.3);
}

.header-icon {
	color: white;
	font-size: 2rem;
}

.header-text {
	flex: 1;
}

.header-title {
	font-size: 1.75rem;
	font-weight: 700;
	color: white;
	margin: 0;
	text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
	letter-spacing: -0.5px;
}

.card-content {
	padding: 2.5rem;
	padding-bottom: 3rem;
	background: #fafbfc;
	overflow-y: auto;
	max-height: calc(100vh - 200px);
}

/* Scrollbar personalizado para el contenido */
.card-content::-webkit-scrollbar {
	width: 8px;
}

.card-content::-webkit-scrollbar-track {
	background: #f1f1f1;
	border-radius: 4px;
}

.card-content::-webkit-scrollbar-thumb {
	background: #888;
	border-radius: 4px;
}

.card-content::-webkit-scrollbar-thumb:hover {
	background: #555;
}

/* Animaciones */
@keyframes fadeInUp {
	from {
		opacity: 0;
		transform: translateY(30px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

@keyframes fadeInScale {
	from {
		opacity: 0;
		transform: scale(0.9);
	}
	to {
		opacity: 1;
		transform: scale(1);
	}
}

@keyframes slideInLeft {
	from {
		opacity: 0;
		transform: translateX(-20px);
	}
	to {
		opacity: 1;
		transform: translateX(0);
	}
}

@keyframes pulse {
	0%,
	100% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.1);
	}
}

@keyframes shine {
	0% {
		transform: translateX(-100%) translateY(-100%) rotate(45deg);
	}
	100% {
		transform: translateX(100%) translateY(100%) rotate(45deg);
	}
}

@keyframes float {
	0%,
	100% {
		transform: translateY(0);
	}
	50% {
		transform: translateY(-10px);
	}
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

@media (max-width: 768px) {
	.card-content {
		padding: 1.5rem;
		padding-bottom: 2rem;
	}

	.header-gradient {
		padding: 1.5rem;
	}

	.header-main {
		flex-direction: column;
		align-items: flex-start;
		gap: 1rem;
	}

	.header-icon-wrapper {
		width: 56px;
		height: 56px;
	}

	.header-icon {
		font-size: 1.75rem;
	}

	.header-title {
		font-size: 1.5rem;
	}
}

@media (max-width: 480px) {
	.card-content {
		padding: 1.25rem;
		padding-bottom: 1.75rem;
	}

	.header-gradient {
		padding: 1.25rem;
	}
}
</style>
